import {
  Orderer,
  StoreUiTodistusPyyntö,
  TodistusPyyntö,
  UnpersistedBackendTodistusPyyntö,
} from 'todistukset-common/src/vtj/types/todistus'
import { Country } from 'todistukset-common/src/vtj/Country.enum'
import { isCountryInEUByCode } from 'todistukset-common/src/vtj/country.util'
import { EuCountries } from 'todistukset-common/src/vtj/EuCountries.enum'
import { UsageRegionTarget } from 'todistukset-common/src/vtj/UsageRegionTarget.enum'
import AuthenticationSource from 'common/src/vtj/AuthenticationSource.enum'
import {
  finalEditableFieldValue,
  isEditableField,
  UaetTodistusKieli,
  VihkivaltioUAET,
} from 'todistukset-common/src/vtj/types/editable-field.type'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import CertificateTypes, {
  isVtjOteTodistus,
} from 'todistukset-common/src/vtj/CertificateTypes.enum'

export const isTranslationFormAvailableUaet = ({
  todistusLanguage,
  placeOfMarriage,
}: {
  todistusLanguage: UaetTodistusKieli | null
  placeOfMarriage: VihkivaltioUAET | null
}): boolean => {
  return (
    [LanguageCode.FI, LanguageCode.SV].some(
      (lang) => lang === finalEditableFieldValue(todistusLanguage)
    ) && isCountryInEUByCode(finalEditableFieldValue(placeOfMarriage))
  )
}

export const checkIfMailDeliveryIsEnabled = ({
  usageRegion,
  orderer: { authenticationSource },
}: {
  usageRegion:
    | StoreUiTodistusPyyntö['usageRegion']
    | UnpersistedBackendTodistusPyyntö['usageRegion']
    | TodistusPyyntö['usageRegion']
  orderer: Pick<Orderer, 'authenticationSource'>
}): boolean => {
  if (authenticationSource === AuthenticationSource.EIDAS) {
    return true
  }

  if (isEditableField(usageRegion)) {
    // For EU authority the usage region country is set to FINLAND
    return finalEditableFieldValue(usageRegion) !== Country.FINLAND
  }

  return (
    usageRegion.countryKoodistoCode !== EuCountries.FINLAND &&
    usageRegion.target !== UsageRegionTarget.EU_AUTHORITY
  )
}

export const getIsAURA = (todistuspyynto: {
  todistusType: CertificateTypes
  usageRegion:
    | StoreUiTodistusPyyntö['usageRegion']
    | UnpersistedBackendTodistusPyyntö['usageRegion']
    | TodistusPyyntö['usageRegion']
  orderer: Pick<Orderer, 'authenticationSource'>
}): boolean => {
  return (
    isVtjOteTodistus(todistuspyynto.todistusType) &&
    !checkIfMailDeliveryIsEnabled(todistuspyynto)
  )
}
